import styled from '@emotion/styled'
import { InputLabel } from '@mui/material'
import { color } from 'config/color'


export const FormLabel = styled(InputLabel)({
    fontSize: 12,
    color: color.grey[700],
    textTransform: 'uppercase',
    letterSpacing: 2,
    marginBottom: 5,
    whiteSpace: 'normal',
    wordWrap: 'break-word'
})
